import Labels from "./ui/constant/labels";
import GeneralBloc from "./bloc/general_bloc";
import AuthBloc from "./bloc/auth_bloc";
import Constants from "./ui/constant/constants";

const Config = {
  context: "myCUEPACSCare",
  channel: "portal",
  entityMapping: {},
  entity: {},
  locale: {
    en: "EN",
    bm: "BM",
  },
  modules: {},
  labelPrefix: {
    errorTitle: "ERRTITLE_",
    errorDesc: "ERRDESC_",
  },
  cache: {
    languageKey: "PRUESUB_SELECTED_LANG",
    localeKey: "PRUESUB_LOCALE_LIBRARY",
    sessionID: "SESSIONID_",
    productScreens: "PRUESUB_PRODUCT_SCREENS_",
    screenDetail: "PRUESUB_SCREEN_DETAIL_",
    partnerDetail: "PRUESUB_PARTNER_DETAIL_",
  },
  client: {
    type: {
      customer: "CUSTOMER",
      payor: "PAYOR",
    },
    idType: {
      nric: "NRIC",
      passport: "Passport",
    },
    gender: {
      male: "Male",
      female: "Female",
    },
  },
  routes: {
    assetsContext: "/myCUEPACSCare",
    entity: {},
    generic: {
      login: "login",
      client_details_screen:"client_details_screen",
      otp_screen:"otp_screen",
      successful_registration:"successful_registration",
      member_details_screen:"member_details_screen",
      documents_screen:"documents_screen",
      
      home: "dashboard",
      dashboard: "dashboard",
      agent_management:"agent_management",
      agent_management_details:"agent_management_details",
      agent_management_find:"agent_management_find",
      file_upload:"file_upload",
      add_file_upload:"add_file_upload",
      proposal: "proposal",
      proposal_preview: "proposal/preview",
      proposal_pending: "proposal_pending",
      proposal_processing: "proposal_processing",
      proposal_processed: "proposal_processed",
      proposal_search: "proposal_search",
      proposal_view: "proposal_view",
      contact_proposal: "proposal/contact",
      quotation: "quotation",
      contact_quotation: "quotation/contact",
      faq: "faq",
      quicklinks: "quicklinks",
      select_quotation: "select_quotation",
      contact: "contact",
      contact_select: "contact/select",
      contact_create: "contact/create",
      proposal_quotation_contact: "contact/view/transactions",
      proposal_or_quotation_contact: "contact/view/proposal_quotation",
      contact_edit: "contact/edit",
      contact_details: "contact/details",
      authentication: "authentication",
      verification: "verification",
      client_proposal: "proposal",
      client_declaration: "declaration",
      client_signature: "signature",
      client_success_review: "success_review",
      client_expired_link: "expired_link",
      client_invalid_link: "invalid_link",
      client_declaration_and_sign: "delcaration_and_sign",
      client_confirmation: "confirmation",
      quotation_personal_details: "quotation_steps/personal_details",
      quotation_product_selection: "quotation_steps/product_selection",
      quotation_financial_details: "quotation_steps/financial_details",
      quotation_product_details: "quotation_steps/product_details",
      quotation_takaful_details: "quotation_steps/takaful_details",
      quotation_review_submit: "quotation_steps/review_submit",

      proposal_provide_details: "proposal_steps/provide_details",
      proposal_health_questionnaries: "proposal_steps/health_questionnaries",
      proposal_upload_documents: "proposal_steps/upload_documents",
      proposal_review: "proposal_steps/review",
      proposal_consent_declaration: "proposal_steps/consent_declaration",
    },
    journey: {
      personalDetail: "personalDetail",
    },
  },
  error: {
    labelNotFound: "<Missing label>",
  },
  searchCriteriaValidationType: {
    //1 = no symbols
    //2 = no numbers
    //3 = no letters & symbols
    //4 = no validation
    certificateNumber: 1,
    participantName: 2,
    participantId: 1,
    mobileNumber: 3,
    coveredName: 2,
    coveredId: 1,
    claimRefNo: 4,
    bankReferenceNumber: 4,
  },

  filterSearchButtonConfig: [
    {
      label: "All",
      code: "ALL",
      selected: true,
    },
    {
      label: "Pending Supervisor",
      code: "PENDING_DC_SP",
      selected: false,
    },
    {
      label: "Rejected by Supervisor",
      code: "REJECTED_SP",
      selected: false,
    },
    {
      label: "Pending CAC/WLOC",
      code: "PENDING_DC_CAC",
      selected: false,
    },
    {
      label: "Rejected by CAC/WLOC",
      code: "REJECTED_CAC",
      selected: false,
    },
    {
      label: "Approved",
      code: "APPROVED",
      selected: false,
    },
    {
      label: "Sent to PAMB",
      code: "SUBMITTED",
      selected: false,
    },
  ],

  checker_approval_list: {
    statusMapping: {
      PROCESSING: {
        label: "Processing",
        color: "white",
        nextLabel: Labels.LBL_UPDATE_PROPOSAL,
        title: "You are the viewer for this proposal",
        description:
          "While you are viewing this proposal, it won’t be available for other approvers to view. Please click on RELEASE PROPOSAL if you do not wish to view this proposal.",
        sms: true,
        icon:
          GeneralBloc.getAssetsContextPath() +
          `/assets/icons/important_notice.svg`,
        reviewed: false,
        backgroundColor: "rgb(255, 229, 221)",
      },
      ACCEPTED: {
        label: "Accepted",
        color: "white",
        title: "LBL_IMPORTANT_NOTICE_SUBMITTED_PROPOSAL_DETAILS",
        description: "LBL_IMPORTANT_NOTICE_DESC_SUBMITTED_PROPOSAL_DETAILS",
        nextLabel: Labels.LBL_SUBMIT_REQUOTATION,
        sms: false,
        icon:
          GeneralBloc.getAssetsContextPath() + `/assets/icons/valid_icon.svg`,
        reviewed: true,
        backgroundColor: "rgb(255, 229, 221)",
      },
      PENDING_DC_SP: {
        label: "Pending Supervisor",
        color: "white",
        nextLabel: Labels.LBL_UPDATE_PROPOSAL,
        title: "You are the viewer for this proposal",
        description:
          "While you are viewing this proposal, it won’t be available for other approvers to view. Please click on CANCEL VIEWING if you do not wish to view this proposal.",
        sms: true,
        icon:
          GeneralBloc.getAssetsContextPath() +
          `/assets/icons/important_notice.svg`,
        reviewed: false,
        backgroundColor: "rgb(255, 229, 221)",
      },
      PENDING_DC_CAC: {
        label: "Pending CAC",
        color: "white",
        nextLabel: Labels.LBL_UPDATE_PROPOSAL,
        title: "You are the viewer for this proposal",
        description:
          "While you are viewing this proposal, it won’t be available for other approvers to view. Please click on CANCEL VIEWING if you do not wish to view this proposal.",
        sms: true,
        icon:
          GeneralBloc.getAssetsContextPath() +
          `/assets/icons/important_notice.svg`,
        reviewed: false,
        backgroundColor: "rgb(255, 229, 221)",
      },

      REJECTED_SP: {
        label: "Rejected by Supervisor",
        color: "white",
        nextLabel: null,
        title: "Reason of Rejection",
        description: null,
        sms: true,
        icon: GeneralBloc.getAssetsContextPath() + `/assets/icons/Warning.svg`,
        reviewed: false,
        backgroundColor: "rgb(255, 229, 221)",
      },
      REJECTED_CAC: {
        label: "Rejected by CAC",
        color: "white",
        nextLabel: null,
        title: "Reason of Rejection",
        description: null,
        sms: true,
        icon: GeneralBloc.getAssetsContextPath() + `/assets/icons/Warning.svg`,
        reviewed: false,
        backgroundColor: "rgb(255, 229, 221)",
      },
      APPROVED: {
        label: "Approved",
        color: "white",
        nextLabel: null,
        title: "Proposal Accepted",
        description: "",
        sms: true,
        icon:
          GeneralBloc.getAssetsContextPath() +
          `/assets/icons/important_notice.svg`,
        reviewed: false,
        backgroundColor: "rgba(124, 177, 255, 0.3)",
      },
      SUBMITTED: {
        label: "Submitted",
        color: "white",
        nextLabel: null,
        title: "Proposal Accepted",
        description: "",
        sms: true,
        icon:
          GeneralBloc.getAssetsContextPath() +
          `/assets/icons/important_notice.svg`,
        reviewed: false,
        backgroundColor: "rgba(124, 177, 255, 0.3)",
      },
    },
    dataTableCollumnMapping: [
      {
        title: "Proposal No",
        key: "proposalNo",
        dataIndex: "proposalNo",
        width: 200,
      },
      {
        title: "Customer Name",
        key: "customerName",
        dataIndex: "customerName",
        width: 200,
      },
      {
        title: "Agent Name",
        key: "salesRepresentativeName",
        dataIndex: "salesRepresentativeName",
        width: 200,
      },
      {
        title: "Agent ID",
        key: "salesRepresentativeID",
        dataIndex: "salesRepresentativeID",
        width: 200,
      },
      {
        title: "Plan Name",
        key: "planName",
        dataIndex: "planName",
        width: 200,
      },
      {
        title: "Branch Name",
        key: "branchname",
        dataIndex: "branchname",
        width: 200,
      },
      {
        title: "Submission Date",
        key: "salesRepresentativeSubmissionDate",
        dataIndex: "salesRepresentativeSubmissionDate",
        width: 200,
        //ellipsis: true,
      },
      {
        title: "Submission Expiry Date",
        key: "submissionExpiryDate",
        dataIndex: "submissionExpiryDate",
        width: 200,
        //ellipsis: true,
      },
      {
        title: "Status",
        key: "trxStatus",
        dataIndex: "trxStatus",
        width: 200,
      },
      {
        title: "Action",
        key: "action",
        dataIndex: "action",
        fixed: "right",
        width: 100,
      },
    ],
    dataCACPendingAndProcessingTableCollumnMapping: [
      {
        title: "Proposal No",
        key: "proposalNo",
        dataIndex: "proposalNo",
        width: 200,
      },
      {
        title: "Customer Name",
        key: "customerName",
        dataIndex: "customerName",
        width: 200,
      },
      {
        title: "Agent Name",
        key: "salesRepresentativeName",
        dataIndex: "salesRepresentativeName",
        width: 200,
      },
      {
        title: "Agent ID",
        key: "salesRepresentativeID",
        dataIndex: "salesRepresentativeID",
        width: 200,
      },
      {
        title: "Plan Name",
        key: "planName",
        dataIndex: "planName",
        width: 200,
      },
      {
        title: "Branch Name",
        key: "branchname",
        dataIndex: "branchname",
        width: 200,
      },
      {
        title: "Submission Date",
        key: "salesRepresentativeSubmissionDate",
        dataIndex: "salesRepresentativeSubmissionDate",
        width: 200,
        //ellipsis: true,
      },
      {
        title: "Submission Expiry Date",
        key: "submissionExpiryDate",
        dataIndex: "submissionExpiryDate",
        width: 200,
        //ellipsis: true,
      },
      {
        title: "Supervisor's Name",
        key: "supervisorName",
        dataIndex: "supervisorName",
        width: 200,
        //ellipsis: true,
      },
      {
        title: "Supervisor's Action Date",
        key: "supervisorActionDate",
        dataIndex: "supervisorActionDate",
        width: 200,
        //ellipsis: true,
      },
      {
        title: "Status",
        key: "trxStatus",
        dataIndex: "trxStatus",
        width: 200,
      },
      {
        title: "Action",
        key: "action",
        dataIndex: "action",
        fixed: "right",
        width: 100,
      },
    ],
    dataCACProcessedTableCollumnMapping: [
      {
        title: "Proposal No",
        key: "proposalNo",
        dataIndex: "proposalNo",
        width: 200,
      },
      {
        title: "Customer Name",
        key: "customerName",
        dataIndex: "customerName",
        width: 200,
      },
      {
        title: "Agent Name",
        key: "salesRepresentativeName",
        dataIndex: "salesRepresentativeName",
        width: 200,
      },
      {
        title: "Agent ID",
        key: "salesRepresentativeID",
        dataIndex: "salesRepresentativeID",
        width: 200,
      },
      {
        title: "Plan Name",
        key: "planName",
        dataIndex: "planName",
        width: 200,
      },
      {
        title: "Branch Name",
        key: "branchname",
        dataIndex: "branchname",
        width: 200,
      },
      {
        title: "Submission Date",
        key: "salesRepresentativeSubmissionDate",
        dataIndex: "salesRepresentativeSubmissionDate",
        width: 200,
        //ellipsis: true,
      },
      {
        title: "Submission Expiry Date",
        key: "submissionExpiryDate",
        dataIndex: "submissionExpiryDate",
        width: 200,
        //ellipsis: true,
      },
      {
        title: "Supervisor's Name",
        key: "supervisorName",
        dataIndex: "supervisorName",
        width: 200,
        //ellipsis: true,
      },
      {
        title: "Supervisor's Action Date",
        key: "supervisorActionDate",
        dataIndex: "supervisorActionDate",
        width: 200,
        //ellipsis: true,
      },
      {
        title: "CAC's Action Date",
        key: "cacActionDate",
        dataIndex: "cacActionDate",
        width: 200,
        //ellipsis: true,
      },
      {
        title: "Status",
        key: "trxStatus",
        dataIndex: "trxStatus",
        width: 200,
      },
      {
        title: "Action",
        key: "action",
        dataIndex: "action",
        fixed: "right",
        width: 100,
      },
    ],
    dataCACSearchTableCollumnMapping: [
      {
        title: "Proposal No",
        key: "proposalNo",
        dataIndex: "proposalNo",
        width: 200,
      },
      {
        title: "Customer Name",
        key: "customerName",
        dataIndex: "customerName",
        width: 200,
      },
      {
        title: "Agent Name",
        key: "salesRepresentativeName",
        dataIndex: "salesRepresentativeName",
        width: 200,
      },
      {
        title: "Agent ID",
        key: "salesRepresentativeID",
        dataIndex: "salesRepresentativeID",
        width: 200,
      },
      {
        title: "Plan Name",
        key: "planName",
        dataIndex: "planName",
        width: 200,
      },
      {
        title: "Branch Name",
        key: "branchname",
        dataIndex: "branchname",
        width: 200,
      },
      {
        title: "Submission Date",
        key: "salesRepresentativeSubmissionDate",
        dataIndex: "salesRepresentativeSubmissionDate",
        width: 200,
        //ellipsis: true,
      },
      {
        title: "Submission Expiry Date",
        key: "submissionExpiryDate",
        dataIndex: "submissionExpiryDate",
        width: 200,
        //ellipsis: true,
      },
      {
        title: "Supervisor's Name",
        key: "supervisorName",
        dataIndex: "supervisorName",
        width: 200,
        //ellipsis: true,
      },
      {
        title: "Supervisor's Action Date",
        key: "supervisorActionDate",
        dataIndex: "supervisorActionDate",
        width: 200,
        //ellipsis: true,
      },
      {
        title: "CAC's Name",
        key: "cacName",
        dataIndex: "cacName",
        width: 200,
        //ellipsis: true,
      },
      {
        title: "CAC's Action Date",
        key: "cacActionDate",
        dataIndex: "cacActionDate",
        width: 200,
        //ellipsis: true,
      },
      {
        title: "Status",
        key: "trxStatus",
        dataIndex: "trxStatus",
        width: 200,
      },
      {
        title: "Action",
        key: "action",
        dataIndex: "action",
        fixed: "right",
        width: 100,
      },
    ],
    dataSupervisorSearchTableCollumnMapping: [
      {
        title: "Proposal No",
        key: "proposalNo",
        dataIndex: "proposalNo",
        width: 200,
      },
      {
        title: "Customer Name",
        key: "customerName",
        dataIndex: "customerName",
        width: 200,
      },
      {
        title: "Agent Name",
        key: "salesRepresentativeName",
        dataIndex: "salesRepresentativeName",
        width: 200,
      },
      {
        title: "Agent ID",
        key: "salesRepresentativeID",
        dataIndex: "salesRepresentativeID",
        width: 200,
      },
      {
        title: "Plan Name",
        key: "planName",
        dataIndex: "planName",
        width: 200,
      },
      {
        title: "Branch Name",
        key: "branchname",
        dataIndex: "branchname",
        width: 200,
      },
      {
        title: "Submission Date",
        key: "salesRepresentativeSubmissionDate",
        dataIndex: "salesRepresentativeSubmissionDate",
        width: 200,
        //ellipsis: true,
      },
      {
        title: "Submission Expiry Date",
        key: "submissionExpiryDate",
        dataIndex: "submissionExpiryDate",
        width: 200,
        //ellipsis: true,
      },
      {
        title: "Supervisor's Name",
        key: "supervisorName",
        dataIndex: "supervisorName",
        width: 200,
        //ellipsis: true,
      },
      {
        title: "Supervisor's Action Date",
        key: "supervisorActionDate",
        dataIndex: "supervisorActionDate",
        width: 200,
        //ellipsis: true,
      },
      {
        title: "CAC's Name",
        key: "cacName",
        dataIndex: "cacName",
        width: 200,
        //ellipsis: true,
      },
      {
        title: "CAC's Action Date",
        key: "cacActionDate",
        dataIndex: "cacActionDate",
        width: 200,
        //ellipsis: true,
      },
      {
        title: "Status",
        key: "trxStatus",
        dataIndex: "trxStatus",
        width: 200,
      },
      {
        title: "Action",
        key: "action",
        dataIndex: "action",
        fixed: "right",
        width: 100,
      },
    ],
    dataMapping: {
      body: [
        {
          item: {
            caption: "Proposal No",
            value: "refNo",
          },
        },
        {
          item: {
            caption: "Sales Representative's Name",
            value: "salesRepresentativeName",
          },
        },
        {
          item: {
            caption: "Sales Representative's ID",
            value: "salesRepresentativeID",
          },
        },
        {
          item: {
            caption: "Branch Name",
            value: "branchname",
          },
        },
        {
          item: {
            caption: "Sales Representative Submission Date",
            value: "salesRepresentativeSubmissionDate",
          },
        },
        {
          item: {
            caption: "Submission Expiry Date",
            value: "submissionExpiryDate",
          },
        },
      ],
    },
    actions: {
      PENDING_DC_SP: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_READ) ? "View" : null,
        ],
        urls: ["proposal_view"],
      },
      DRAFT: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_READ) ? "View" : null,
        ],
        urls: ["proposal_view"],
      },
      PROPOSAL_CREATED: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_READ) ? "View" : null,
        ],
        urls: ["proposal_view"],
      },
      PENDING_ACTION_CUST: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_READ) ? "View" : null,
        ],
        urls: ["proposal_view"],
      },
      PENDING_ACTION_AP: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_READ) ? "View" : null,
        ],
        urls: ["proposal_view"],
      },
      PENDING_DC_CAC: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_READ) ? "View" : null,
        ],
        urls: ["proposal_view"],
      },
      PROCESSING_DC_SP: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_READ) ? "View" : null,
          "Cancel Viewing",
        ],
        urls: ["proposal_view", "/"],
      },
      PROCESSING_DC_CAC: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_READ) ? "View" : null,
          "Cancel Viewing",
        ],
        urls: ["proposal_view", "/"],
      },
      REJECTED_SP: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_READ) ? "View" : null,
        ],
        urls: ["proposal_view"],
      },
      REJECTED_CAC: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_READ) ? "View" : null,
        ],
        urls: ["proposal_view"],
      },
      APPROVED: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_READ) ? "View" : null,
        ],
        urls: ["proposal_view"],
      },
      SUBMITTED: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_READ) ? "View" : null,
        ],
        urls: ["proposal_view"],
      },

      UNDEFINED: {
        labels: "Undefined",
        urls: "grey",
      },
    },
  },
  proposal: {
    actions: {
      APPROVED: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_READ)
            ? "Preview All"
            : null,
        ],
        urls: ["proposal"],
      },
      SUBMITTED: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_READ)
            ? "Preview All"
            : null,
        ],
        urls: ["proposal"],
      },
      PENDING_SUBMISSION: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_CREATE)
            ? "Update Proposal"
            : null,
          AuthBloc.accessible("QUOTATION", Constants.ACT_READ)
            ? "View Quotation"
            : null,
        ],
        urls: ["proposal_steps/provide_details", "quotation"],
      },
      PENDING_REVIEW: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_READ)
            ? "View Proposal"
            : null,
          AuthBloc.accessible("QUOTATION", Constants.ACT_READ)
            ? "View Quotation"
            : null,
        ],
        urls: ["proposal_review", "quotation"],
      },
      DRAFT: {
        labels: [
          AuthBloc.accessible("QUOTATION", Constants.ACT_READ)
            ? "View Quotation"
            : null,
          AuthBloc.accessible("PROPOSAL", Constants.ACT_CREATE)
            ? "Update Proposal"
            : null,
          AuthBloc.accessible("PROPOSAL", Constants.ACT_DELETE)
            ? "Delete"
            : null,
        ],
        urls: ["quotation", "proposal_steps/provide_details", "/"],
      },
      PROPOSAL_CREATED: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_CREATE)
            ? "Update Proposal"
            : null,
            AuthBloc.accessible("PROPOSAL",Constants.ACT_DELETE) ? "Delete Proposal" :null,
          AuthBloc.accessible("QUOTATION", Constants.ACT_READ)
            ? "View Quotation"
            : null,
          AuthBloc.accessible("PROPOSAL", Constants.ACT_READ)
            ? "View Proposal"
            : null,
        ],
        urls: ["proposal_steps/provide_details", "quotation", "proposal"],
      },
      PENDING_ACTION_CUST: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_READ)
            ? "Preview All"
            : null,
          AuthBloc.accessible("PROPOSAL", Constants.ACT_CREATE)
            ? "Update Proposal"
            : null,
          AuthBloc.accessible("PROPOSAL", Constants.ACT_DELETE)
            ? "Delete"
            : null,
        ],
        urls: ["proposal", "proposal_steps/provide_details", "/"],
      },
      PENDING_ACTION_AP: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_READ)
            ? "Preview All"
            : null,
          AuthBloc.accessible("PROPOSAL", Constants.ACT_CREATE)
            ? "Update Proposal"
            : null,
          AuthBloc.accessible("PROPOSAL", Constants.ACT_DELETE)
            ? "Delete"
            : null,
        ],
        urls: ["proposal", "proposal_steps/provide_details", "/"],
      },


      PENDING_ACTION_AGENT: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_READ)
            ? "Preview All"
            : null,
          AuthBloc.accessible("PROPOSAL", Constants.ACT_DELETE)
            ? "Delete"
            : null,
        ],
        urls: ["proposal", "/"],
      },
      PENDING_DC_SP: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_READ)
            ? "Preview All"
            : null,
        ],
        urls: ["proposal"],
      },
      PENDING_DC_CAC: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_READ)
            ? "Preview All"
            : null,
        ],
        urls: ["proposal"],
      },
      REJECTED_CAC: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_READ)
            ? "Preview All"
            : null,
          AuthBloc.accessible("PROPOSAL", Constants.ACT_DELETE)
            ? "Delete"
            : null,
        ],
        urls: ["proposal", "/"],
      },
      REJECTED_SP: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_READ)
            ? "Preview All"
            : null,
          AuthBloc.accessible("PROPOSAL", Constants.ACT_DELETE)
            ? "Delete"
            : null,
        ],
        urls: ["proposal", "/"],
      },

      UNDEFINED: {
        labels: "Undefined",
        urls: "grey",
      },
    },
    dataTableCollumnMapping: [
      {
        title: "Proposal Ref No.",
        key: "refNo",
        dataIndex: "refNo",
      },
      {
        title: "Proposal No.",
        key: "proposalNo",
        dataIndex: "proposalNo",
      },
      {
        title: "Customer Name",
        key: "fullName",
        dataIndex: "fullName",
      },
      {
        title: "ID Number",
        key: "idNo",
        dataIndex: "idNo",
      },
      /* {
        title: "Old NRIC No./Passport No.",
        key: "otherIdNo",
        dataIndex: "otherIdNo",
      },   */
      {
        title: "Creation Date",
        key: "createdOn",
        dataIndex: "createdOn",
      },
      {
        title: "Last Update",
        key: "updatedOn",
        dataIndex: "updatedOn",
      },
      {
        title: "Status",
        key: "trxStatus",
        dataIndex: "trxStatus",
      },
      {
        title: "Action",
        key: "action",
        dataIndex: "action",
        fixed: "right",
        width: 100,
      },
    ],
    dataMapping: {
      body: [
        {
          item: {
            caption: "Ref No",
            value: "refNo",
          },
        },
        {
          item: {
            caption: "ID No",
            value: "id",
          },
        },
        {
          item: {
            caption: "Proposal No",
            value: "refNo",
          },
        },
      ],
      footer: [
        {
          item: {
            caption: "Creation Date",
            value: "createdOn",
          },
        },
        {
          item: {
            caption: "Last Update",
            value: "updatedOn",
          },
        },
      ],
    },
    tabBarMapping: {
      all: {
        label: "All",
        value: "ALL",
      },
      draft: { label: "Proposal In Progress", value: "DRAFT" },
      pendingReview: { label: "Pending Review", value: "PENDING_REVIEW" },
      pendingSubmission: {
        label: "Pending Submission",
        value: "PENDING_SUBMISSION",
      },
      approved: {
        label: "Approved",
        value: "APPROVED",
      },
      submitted: {
        label: "Submitted",
        value: "SUBMITTED",
      },
      proposalCreated: {
        label: "Proposal Created",
        value: "PROPOSAL_CREATED",
      },
      pendingActionCustomer: {
        label: "Pending Action Customer",
        value: "PENDING_ACTION_CUST",
      },
      pendingActionCustomer: {
        label: "Pending Action authorized Person",
        value: "PENDING_ACTION_AP",
      },
      pendingActionAgent: {
        label: "Pending Action Agent",
        value: "PENDING_ACTION_AGENT",
      },
      pendingDecisionSupervisor: {
        label: "Pending Supervisor",
        value: "PENDING_DC_SP",
      },
      pendingDecisionCAC: {
        label: "Pending CAC",
        value: "PENDING_DC_CAC",
      },
      rejectedCAC: {
        label: "Rejected by CAC",
        value: "REJECTED_CAC",
      },
      rejectedSupervisor: {
        label: "Rejected by Supervisor",
        value: "REJECTED_SUPERVISOR",
      },
    },
    statusMapping: {
      DRAFT: {
        label: "Proposal In Progress",
        color: "white",
        nextLabel: Labels.LBL_UPDATE_PROPOSAL,
        title: "LBL_IMPORTANT_NOTICE_PENDING_PROPOSAL_DETAILS",
        description: "LBL_IMPORTANT_NOTICE_DESC_PENDING_PROPOSAL_DETAILS",
        sms: true,
        icon:
          GeneralBloc.getAssetsContextPath() +
          `/assets/icons/important_notice.svg`,
        reviewed: false,
      },
      PENDING_REVIEW: {
        label: "Pending Review",
        color: "white",
        title: "LBL_IMPORTANT_NOTICE_PENDING_REVIEW_PROPOSAL_DETAILS",
        description:
          "LBL_IMPORTANT_NOTICE_DESC_PENDING_REVIEW_PROPOSAL_DETAILS",
        nextLabel: Labels.LBL_UPDATE_PROPOSAL,
        sms: true,
        icon:
          GeneralBloc.getAssetsContextPath() +
          `/assets/icons/important_notice.svg`,
        reviewed: false,
      },
      PENDING_SUBMISSION: {
        label: "Pending Submission",
        color: "white",
        title: "LBL_IMPORTANT_NOTICE_PENDING_SUBMISSION_PROPOSAL_DETAILS",
        description:
          "LBL_IMPORTANT_NOTICE_DESC_PENDING_SUBMISSION_PROPOSAL_DETAILS",
        nextLabel: Labels.LBL_SUBMIT_PROPOSAL,
        sms: false,
        icon:
          GeneralBloc.getAssetsContextPath() +
          `/assets/icons/pending_submission.svg`,
        reviewed: true,
      },
      SUBMITTED: {
        label: "Submitted",
        color: "white",
        title: "LBL_IMPORTANT_NOTICE_SUBMITTED_PROPOSAL_DETAILS",
        description: "LBL_IMPORTANT_NOTICE_DESC_SUBMITTED_PROPOSAL_DETAILS",
        nextLabel: Labels.LBL_SUBMIT_REQUOTATION,
        sms: false,
        icon:
          GeneralBloc.getAssetsContextPath() +
          `/assets/icons/important_notice.svg`,
        reviewed: true,
      },
      APPROVED: {
        label: "Approved",
        color: "white",
        title: "LBL_IMPORTANT_NOTICE_SUBMITTED_PROPOSAL_DETAILS",
        description: "LBL_IMPORTANT_NOTICE_DESC_SUBMITTED_PROPOSAL_DETAILS",
        nextLabel: Labels.LBL_SUBMIT_REQUOTATION,
        sms: false,
        icon:
          GeneralBloc.getAssetsContextPath() +
          `/assets/icons/important_notice.svg`,
        reviewed: true,
      },
      PENDING_ACTION_CUST: {
        label: "Pending Customer",
        color: "white",
        title: "LBL_IMPORTANT_NOTICE_PENDING_PROPOSAL_DETAILS",
        description: "LBL_IMPORTANT_NOTICE_PENDING_PROPOSAL_DETAILS",
        nextLabel: Labels.LBL_UPDATE_PROPOSAL,
        sms: false,
        reviewed: false,
        icon: null,
      },
      PENDING_ACTION_AP: {
        label: "Pending Authorized Person",
        color: "white",
        title: "LBL_IMPORTANT_NOTICE_PENDING_PROPOSAL_DETAILS",
        description: "LBL_IMPORTANT_NOTICE_PENDING_PROPOSAL_DETAILS",
        nextLabel: Labels.LBL_UPDATE_PROPOSAL,
        sms: false,
        reviewed: false,
        icon: null,
      },
      PROPOSAL_CREATED: {
        label: "Proposal In Progress",
        color: "white",
        title: "LBL_IMPORTANT_NOTICE_PENDING_PROPOSAL_DETAILS",
        description: "LBL_IMPORTANT_NOTICE_PENDING_PROPOSAL_DETAILS",
        nextLabel: Labels.LBL_UPDATE_PROPOSAL,
        sms: false,
        reviewed: false,
        icon: null,
      },
      PENDING_ACTION_AGENT: {
        label: "Pending Sales Representative",
        color: "white",
        title: "LBL_IMPORTANT_NOTICE_PENDING_PROPOSAL_DETAILS",
        description: "LBL_IMPORTANT_NOTICE_PENDING_PROPOSAL_DETAILS",
        nextLabel: Labels.LBL_SUBMIT_PROPOSAL,
        sms: false,
        reviewed: false,
        icon: null,
      },
      PENDING_DC_SP: {
        label: "Pending Supervisor",
        color: "white",
        title: "LBL_IMPORTANT_NOTICE_PENDING_PROPOSAL_DETAILS",
        description: "LBL_IMPORTANT_NOTICE_PENDING_PROPOSAL_DETAILS",
        nextLabel: Labels.LBL_UPDATE_PROPOSAL,
        sms: false,
        reviewed: false,
        icon: null,
      },
      REJECTED_SP: {
        label: "Rejected by Supervisor",
        color: "white",
        title: "LBL_IMPORTANT_NOTICE_PENDING_PROPOSAL_DETAILS",
        description: "LBL_IMPORTANT_NOTICE_PENDING_PROPOSAL_DETAILS",
        nextLabel: Labels.LBL_UPDATE_PROPOSAL,
        sms: false,
        reviewed: false,
        icon: null,
      },
      PENDING_DC_CAC: {
        label: "Pending CAC",
        color: "white",
        title: "LBL_IMPORTANT_NOTICE_PENDING_PROPOSAL_DETAILS",
        description: "LBL_IMPORTANT_NOTICE_PENDING_PROPOSAL_DETAILS",
        nextLabel: Labels.LBL_UPDATE_PROPOSAL,
        sms: false,
        reviewed: false,
        icon: null,
      },
      REJECTED_CAC: {
        label: "Rejected by CAC",
        color: "white",
        title: "LBL_IMPORTANT_NOTICE_PENDING_PROPOSAL_DETAILS",
        description: "LBL_IMPORTANT_NOTICE_PENDING_PROPOSAL_DETAILS",
        nextLabel: Labels.LBL_UPDATE_PROPOSAL,
        sms: false,
        reviewed: false,
        icon: null,
      },
      REJECTED_SUPERVISOR: {
        label: "Rejected by Supervisor",
        color: "white",
        title: "LBL_IMPORTANT_NOTICE_PENDING_PROPOSAL_DETAILS",
        description: "LBL_IMPORTANT_NOTICE_PENDING_PROPOSAL_DETAILS",
        nextLabel: Labels.LBL_UPDATE_PROPOSAL,
        sms: false,
        reviewed: false,
        icon: null,
      },
      UNDEFINED: {
        label: "Undefined",
        color: "white",
        title: "LBL_IMPORTANT_NOTICE_PENDING_PROPOSAL_DETAILS",
        description: "LBL_IMPORTANT_NOTICE_PENDING_PROPOSAL_DETAILS",
        nextLabel: Labels.LBL_UPDATE_PROPOSAL,
        sms: false,
        reviewed: false,
        icon: null,
      },
    },
  },
  quotation: {
    proposal: {
      actions: {
        APPROVED: {
          labels: [
            AuthBloc.accessible("PROPOSAL", Constants.ACT_READ)
              ? "Preview All"
              : null,
          ],
          urls: ["proposal"],
        },
        SUBMITTED: {
          labels: [
            AuthBloc.accessible("PROPOSAL", Constants.ACT_READ)
              ? "Preview All"
              : null,
          ],
          urls: ["proposal"],
        },
        PENDING_SUBMISSION: {
          labels: [
            AuthBloc.accessible("PROPOSAL", Constants.ACT_CREATE)
              ? "Update Proposal"
              : null,
            AuthBloc.accessible("QUOTATION", Constants.ACT_READ)
              ? "View Quotation"
              : null,
          ],
          urls: ["proposal_steps/provide_details", "quotation"],
        },
        PENDING_REVIEW: {
          labels: [
            AuthBloc.accessible("PROPOSAL", Constants.ACT_READ)
              ? "View Proposal"
              : null,
            AuthBloc.accessible("QUOTATION", Constants.ACT_READ)
              ? "View Quotation"
              : null,
          ],
          urls: ["proposal_review", "quotation"],
        },
        DRAFT: {
          labels: [
            AuthBloc.accessible("QUOTATION", Constants.ACT_READ)
              ? "View Quotation"
              : null,
            AuthBloc.accessible("PROPOSAL", Constants.ACT_CREATE)
              ? "Update Proposal"
              : null,
            AuthBloc.accessible("PROPOSAL", Constants.ACT_DELETE)
              ? "Delete"
              : null,
          ],
          urls: ["quotation", "proposal_steps/provide_details", "/"],
        },
        PROPOSAL_CREATED: {
          labels: [
            AuthBloc.accessible("PROPOSAL", Constants.ACT_CREATE)
              ? "Update Proposal"
              : null,
            AuthBloc.accessible("PROPOSAL",Constants.ACT_DELETE) ? "Delete Proposal" : null,
            AuthBloc.accessible("QUOTATION", Constants.ACT_READ)
              ? "View Quotation"
              : null,
            AuthBloc.accessible("PROPOSAL", Constants.ACT_READ)
              ? "View Proposal"
              : null,
          ],
          urls: ["proposal_steps/provide_details", "quotation", "proposal"],
        },
        PENDING_ACTION_CUST: {
          labels: [
            AuthBloc.accessible("PROPOSAL", Constants.ACT_READ)
              ? "Preview All"
              : null,
            AuthBloc.accessible("PROPOSAL", Constants.ACT_CREATE)
              ? "Update Proposal"
              : null,
            AuthBloc.accessible("PROPOSAL", Constants.ACT_DELETE)
              ? "Delete"
              : null,
          ],
          urls: ["proposal", "proposal_steps/provide_details", "/"],
        },
        PENDING_ACTION_AP: {
          labels: [
            AuthBloc.accessible("PROPOSAL", Constants.ACT_READ)
              ? "Preview All"
              : null,
            AuthBloc.accessible("PROPOSAL", Constants.ACT_CREATE)
              ? "Update Proposal"
              : null,
            AuthBloc.accessible("PROPOSAL", Constants.ACT_DELETE)
              ? "Delete"
              : null,
          ],
          urls: ["proposal", "proposal_steps/provide_details", "/"],
        },
        PENDING_ACTION_AGENT: {
          labels: [
            AuthBloc.accessible("PROPOSAL", Constants.ACT_READ)
              ? "Preview All"
              : null,
            AuthBloc.accessible("PROPOSAL", Constants.ACT_DELETE)
              ? "Delete"
              : null,
          ],
          urls: ["proposal", "/"],
        },
        PENDING_DC_SP: {
          labels: [
            AuthBloc.accessible("PROPOSAL", Constants.ACT_READ)
              ? "Preview All"
              : null,
          ],
          urls: ["proposal"],
        },
        PENDING_DC_CAC: {
          labels: [
            AuthBloc.accessible("PROPOSAL", Constants.ACT_READ)
              ? "Preview All"
              : null,
          ],
          urls: ["proposal"],
        },
        REJECTED_CAC: {
          labels: [
            AuthBloc.accessible("PROPOSAL", Constants.ACT_READ)
              ? "Preview All"
              : null,
            AuthBloc.accessible("PROPOSAL", Constants.ACT_DELETE)
              ? "Delete"
              : null,
          ],
          urls: ["proposal", "/"],
        },
        REJECTED_SP: {
          labels: [
            AuthBloc.accessible("PROPOSAL", Constants.ACT_READ)
              ? "Preview All"
              : null,
            AuthBloc.accessible("PROPOSAL", Constants.ACT_DELETE)
              ? "Delete"
              : null,
          ],
          urls: ["proposal", "/"],
        },

        UNDEFINED: {
          labels: "Undefined",
          urls: "grey",
        },
      },
    },
    actions: {
      DRAFT: {
        labels: [
          AuthBloc.accessible("QUOTATION", Constants.ACT_CREATE)
            ? "Edit Quotation"
            : "",

          AuthBloc.accessible("QUOTATION", Constants.ACT_DELETE)
            ? "Delete"
            : null,
        ],
        urls: ["quotation_steps/personal_details", "/"],
      },
      PENDING: {
        labels: [
          AuthBloc.accessible("QUOTATION", Constants.ACT_CREATE)
            ? "Edit Quotation"
            : "",

          AuthBloc.accessible("QUOTATION", Constants.ACT_DELETE)
            ? "Delete"
            : null,
        ],
        urls: ["quotation_steps/personal_details", "/"],
        /* labels: [
          AuthBloc.accessible("QUOTATION", Constants.ACT_CREATE)
            ? "Update Quotation"
            : "",
          AuthBloc.accessible("QUOTATION", Constants.ACT_READ)
            ? "View Quotation"
            : null,
          // "Requote",
          AuthBloc.accessible("QUOTATION", Constants.ACT_DELETE)
            ? "Delete"
            : null,
        ],
        urls: ["quotation_steps/personal_details", "quotation", "/"], */
      },
      GENERATED: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_CREATE)
            ? "Update Proposal"
            : null,
          AuthBloc.accessible("QUOTATION", Constants.ACT_READ)
            ? "View Quotation"
            : null,
          AuthBloc.accessible("QUOTATION", Constants.ACT_DELETE)
            ? "Delete"
            : null,
          // "Requote"
        ],
        urls: ["proposal_steps/provide_details", "quotation", "/"],
      },
    },
    dataTableCollumnMapping: [
      {
        title: "Quotation Ref No.",
        key: "refNo",
        dataIndex: "refNo",
      },
      {
        title: "Proposal Ref No.",
        key: "proposalRefNo",
        dataIndex: "proposalRefNo",
      },
      {
        title: "Proposal No.",
        key: "proposalNo",
        dataIndex: "proposalNo",
      },
      {
        title: "Customer Name",
        key: "fullName",
        dataIndex: "fullName",
      },
      /* {
        title: "New NRIC No.",
        key: "idNo",
        dataIndex: "idNo",
      },
      {
        title: "Old NRIC No./Passport No.",
        key: "otherIdNo",
        dataIndex: "otherIdNo",
      },   */
      {
        title: "Creation Date",
        key: "createdOn",
        dataIndex: "createdOn",
      },
      {
        title: "Last Update",
        key: "updatedOn",
        dataIndex: "updatedOn",
      },
      {
        title: "Status",
        key: "trxStatus",
        dataIndex: "trxStatus",
      },
      {
        title: "Action",
        key: "action",
        dataIndex: "action",
        fixed: "right",
        width: 100,
      },
    ],
    dataMapping: {
      body: [
        {
          item: {
            caption: "Ref No",
            value: "refNo",
          },
        },
        {
          item: {
            caption: "ID No",
            value: "id",
          },
        },
      ],
      footer: [
        {
          item: {
            caption: "Creation Date",
            value: "createdOn",
          },
        },
        {
          item: {
            caption: "Last Update",
            value: "updatedOn",
          },
        },
      ],
    },
    tabBarMapping: {
      all: {
        label: "All",
        value: "ALL",
      },
      draft: { label: "Draft", value: "DRAFT" },
      pending: { label: "Pending", value: "PENDING" },
      generated: { label: "Generated", value: "GENERATED" },
    },
    statusMapping: {
      GENERATED: {
        label: "Quotation Created",
        color: "white",
      },
      PENDING: {
        label: "Quotation In Progress",
        color: "white",
      },
      DRAFT: {
        label: "Quotation In Progress",
        color: "white",
      },
      UNDEFINED: {
        label: "Undefined",
        color: "white",
      },
    },
    dataDetailMapping: {
      personalDetails: [
        {
          item1: "purposeOfProposal",
          item2: null,
        },
        {
          item1: "name",
          item2: "gender",
        },
        {
          item1: "dob",
          item2: "anb",
        },
        {
          item1: "occupation",
          item2: "nob",
        },
        {
          item1: "occupationClass",
          item2: null,
        },
        {
          item1: "email",
          item2: "smoked",
        },
      ],
      mortgageCover: [
        {
          item1: "loanAccountNo",
          item2: "loanAmount",
        },
        {
          item1: "loanTenure",
          item2: "constructionPeriod",
        },
        {
          item1: "loanInterestRate",
          item2: "initialSumAssured",
        },
        {
          item1: "productName",
          item2: "defermentTerm",
        },
        {
          item1: "termOfCoverage",
          item2: "refundOfPremiumRider",
        },
        {
          item1: "singlePremiumToBeAssured",
          item2: null,
        },
      ],
      productSelection: [
        {
          item1: "productSelection",
          item2: null,
        },
        {
          item1: "paymentFrequency",
          item2: null,
        },
        {
          item1: "paymentMode",
          item2: "paymentMethod",
        },
        {
          item1: "anb",
          item2: "inceptionDate",
        },
      ],

      uploaded_document: [
        {
          item1: "termOfCoverage",
          item2: "initialSumCovered",
        },
        {
          item1: "contributionAmount",
          item2: "contributionMode",
        },
      ],
    },
  },
  contact: {
    actions: {
      DRAFT: {
        labels: [
          AuthBloc.accessible("QUOTATION", Constants.ACT_CREATE)
            ? "Generate Quotation"
            : null,
          AuthBloc.accessible("CONTACT", Constants.ACT_CREATE)
            ? "Update Contact"
            : null,
          AuthBloc.accessible("CONTACT", Constants.ACT_DELETE)
            ? "Delete"
            : null,
          AuthBloc.accessible("CONTACT", Constants.ACT_READ)
            ? "View Transactions"
            : null,
        ],
        urls: [
          "quotation_steps/personal_details",
          "contact/edit",
          "/",
          "contact/view/transactions",
        ],
      },
      PENDING: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_CREATE)
            ? "Proceed to Proposal"
            : null,
          AuthBloc.accessible("QUOTATION", Constants.ACT_CREATE)
            ? "View Quotation"
            : null,
          // "Requote",
          AuthBloc.accessible("CONTACT", Constants.ACT_DELETE)
            ? "Delete"
            : null,
          AuthBloc.accessible("CONTACT", Constants.ACT_READ)
            ? "View Transactions"
            : null,
        ],
        urls: [
          "select_quotation",
          "quotation",
          "quotation_steps/personal_details",
          "contact/view/transactions",
        ],
      },
      GENERATED: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_READ)
            ? "View Proposal"
            : null,
          AuthBloc.accessible("QUOTATION", Constants.ACT_READ)
            ? "View Quotation"
            : null,
          AuthBloc.accessible("CONTACT", Constants.ACT_READ)
            ? "View Transactions"
            : null,
          // "Requote"
        ],
        urls: ["proposal", "quotation", "contact/view/transactions"],
      },
    },
    dataTableCollumnMapping: [
      {
        title: "Customer Name",
        key: "name",
        dataIndex: "name",
      },
      /* {
        title: "New NRIC No.",
        key: "idNo",
        dataIndex: "idNo",
      },
      {
        title: "Old NRIC No./Passport No.",
        key: "otherIdNo",
        dataIndex: "otherIdNo",
      }, */
      {
        title: "Date Of Birth",
        key: "dob",
        dataIndex: "dob",
      },
      {
        title: "Email Address",
        key: "email",
        dataIndex: "email",
      },
      {
        title: "Last Update",
        key: "lastTransaction",
        dataIndex: "lastTransaction",
      },
      {
        title: "No. Of Quotation Created",
        key: "quotationCount",
        dataIndex: "quotationCount",
      },
      {
        title: "No. Of Proposal Created",
        key: "proposalCount",
        dataIndex: "proposalCount",
      },
      {
        title: "Action",
        key: "action",
        dataIndex: "action",
        fixed: "right",
        width: 100,
      },
    ],
    dataMapping: {
      body: [
        {
          item: {
            caption: "Customer Name",
            value: "name",
          },
        },
        {
          item: {
            caption: "New NRIC No.",
            value: "idNo",
          },
        },
        {
          item: {
            caption: "Old NRIC No./Passport No.",
            value: "otherIdNo",
          },
        },
        {
          item: {
            caption: "Date Of Birth",
            value: "dob",
          },
        },
        {
          item: {
            caption: "Email Address",
            value: "email",
          },
        },
        {
          item: {
            caption: "Last transaction",
            value: "lastTransaction",
          },
        },
      ],
      footer: [
        {
          item: {
            caption: "Creation Date",
            value: "createdOn",
          },
        },
        {
          item: {
            caption: "Last Update",
            value: "updatedOn",
          },
        },
      ],
    },
    tabBarMapping: {
      all: {
        label: "All",
        value: "ALL",
      },
      draft: { label: "Draft", value: "DRAFT" },
      pending: { label: "Pending", value: "PENDING" },
      generated: { label: "Generated", value: "GENERATED" },
    },
    statusMapping: {
      DRAFT: {
        label: "Draft",
        color: "#FCEACF",
      },
      PENDING: {
        label: "Pending",
        color: "#FFE5DD",
      },
      GENERATED: {
        label: "Generated",
        color: "#66CCA733",
      },
      UNDEFINED: {
        label: "Undefined",
        color: "grey",
      },
    },
    dataDetailMapping: {
      personalDetails: [
        {
          item1: "name",
          item2: "typeId",
        },
        {
          item1: "idNo",
          item2: "otherIdNo",
        },
        {
          item1: "dob",
          item2: "anb",
        },
        {
          item1: "dateOfQuotation",
          item2: null,
        },
      ],
      financialDetails: [
        {
          item1: "financingBank",
          item2: "financingAccNo",
        },
        {
          item1: "bankRefNo",
          item2: "eligibleB40",
        },
        {
          item1: "financingAmount",
          item2: "financingPercentage",
        },
        {
          item1: "coveredFinancingAmount",
          item2: "assuredBankRate",
        },
        {
          item1: "financingPeriod",
          item2: "derefmentPeriod",
        },
      ],
      takafulDetails: [
        {
          item1: "termOfCoverage",
          item2: "initialSumCovered",
        },
        {
          item1: "contributionAmount",
          item2: "contributionMode",
        },
        {
          item1: "contributionType",
          item2: "financingPercentage",
        },
      ],
      uploaded_document: [
        {
          item1: "termOfCoverage",
          item2: "initialSumCovered",
        },
        {
          item1: "contributionAmount",
          item2: "contributionMode",
        },
      ],
    },
  },
  agent_management: {
    actions: {
      DRAFT: {
        labels: [
          "View/Update"
        ],
        urls: [
          "agent_management_details"
        ],
      },
      PENDING: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_CREATE)
            ? "Proceed to Proposal"
            : null,
          AuthBloc.accessible("QUOTATION", Constants.ACT_CREATE)
            ? "View Quotation"
            : null,
          // "Requote",
          AuthBloc.accessible("CONTACT", Constants.ACT_DELETE)
            ? "Delete"
            : null,
          AuthBloc.accessible("CONTACT", Constants.ACT_READ)
            ? "View Transactions"
            : null,
        ],
        urls: [
          "select_quotation",
          "quotation",
          "quotation_steps/personal_details",
          "contact/view/transactions",
        ],
      },
      GENERATED: {
        labels: [
          AuthBloc.accessible("PROPOSAL", Constants.ACT_READ)
            ? "View Proposal"
            : null,
          AuthBloc.accessible("QUOTATION", Constants.ACT_READ)
            ? "View Quotation"
            : null,
          AuthBloc.accessible("CONTACT", Constants.ACT_READ)
            ? "View Transactions"
            : null,
          // "Requote"
        ],
        urls: ["proposal", "quotation", "contact/view/transactions"],
      },
    },
    dataTableCollumnMapping: [
      {
        title: "Customer Name",
        key: "name",
        dataIndex: "name",
      },
      /* {
        title: "New NRIC No.",
        key: "idNo",
        dataIndex: "idNo",
      },
      {
        title: "Old NRIC No./Passport No.",
        key: "otherIdNo",
        dataIndex: "otherIdNo",
      }, */
      {
        title: "Date Of Birth",
        key: "dob",
        dataIndex: "dob",
      },
      {
        title: "Email Address",
        key: "email",
        dataIndex: "email",
      },
      {
        title: "Last Update",
        key: "lastTransaction",
        dataIndex: "lastTransaction",
      },
      {
        title: "No. Of Quotation Created",
        key: "quotationCount",
        dataIndex: "quotationCount",
      },
      {
        title: "No. Of Proposal Created",
        key: "proposalCount",
        dataIndex: "proposalCount",
      },
      {
        title: "Action",
        key: "action",
        dataIndex: "action",
        fixed: "right",
        width: 100,
      },
    ],
    dataMapping: {
      body: [
        {
          item: {
            caption: "Customer Name",
            value: "name",
          },
        },
        {
          item: {
            caption: "New NRIC No.",
            value: "idNo",
          },
        },
        {
          item: {
            caption: "Old NRIC No./Passport No.",
            value: "otherIdNo",
          },
        },
        {
          item: {
            caption: "Date Of Birth",
            value: "dob",
          },
        },
        {
          item: {
            caption: "Email Address",
            value: "email",
          },
        },
        {
          item: {
            caption: "Last transaction",
            value: "lastTransaction",
          },
        },
      ],
      footer: [
        {
          item: {
            caption: "Creation Date",
            value: "createdOn",
          },
        },
        {
          item: {
            caption: "Last Update",
            value: "updatedOn",
          },
        },
      ],
    },
    tabBarMapping: {
      all: {
        label: "All",
        value: "ALL",
      },
      draft: { label: "Draft", value: "DRAFT" },
      pending: { label: "Pending", value: "PENDING" },
      generated: { label: "Generated", value: "GENERATED" },
    },
    statusMapping: {
      DRAFT: {
        label: "Draft",
        color: "#FCEACF",
      },
      PENDING: {
        label: "Pending",
        color: "#FFE5DD",
      },
      GENERATED: {
        label: "Generated",
        color: "#66CCA733",
      },
      UNDEFINED: {
        label: "Undefined",
        color: "grey",
      },
    },
    dataDetailMapping: {
      personalDetails: [
        {
          item1: "name",
          item2: "typeId",
        },
        {
          item1: "idNo",
          item2: "otherIdNo",
        },
        {
          item1: "dob",
          item2: "anb",
        },
        {
          item1: "dateOfQuotation",
          item2: null,
        },
      ],
      financialDetails: [
        {
          item1: "financingBank",
          item2: "financingAccNo",
        },
        {
          item1: "bankRefNo",
          item2: "eligibleB40",
        },
        {
          item1: "financingAmount",
          item2: "financingPercentage",
        },
        {
          item1: "coveredFinancingAmount",
          item2: "assuredBankRate",
        },
        {
          item1: "financingPeriod",
          item2: "derefmentPeriod",
        },
      ],
      takafulDetails: [
        {
          item1: "termOfCoverage",
          item2: "initialSumCovered",
        },
        {
          item1: "contributionAmount",
          item2: "contributionMode",
        },
        {
          item1: "contributionType",
          item2: "financingPercentage",
        },
      ],
      uploaded_document: [
        {
          item1: "termOfCoverage",
          item2: "initialSumCovered",
        },
        {
          item1: "contributionAmount",
          item2: "contributionMode",
        },
      ],
    },
  },
  file_upload: {
    actions: {
      SUCCESS: {
        labels: [
          "View Uploaded File"
        ],
        urls: [
          "add_file_upload"
        ],
      },
      PARTIAL_SUCCESS: {
        labels: [
          "View Uploaded File",
          "Track Errors"
        ],
        urls: [
          "add_file_upload",
          "track_error"
        ],
      },
      FAILED: {
        labels: [
          "View Uploaded File",
          "Delete File"
        ],
        urls: [
          "add_file_upload",
          "delete_file"
        ],
      },
      
    },
    dataTableCollumnMapping: [
      {
        title: "Customer Name",
        key: "name",
        dataIndex: "name",
      },
      /* {
        title: "New NRIC No.",
        key: "idNo",
        dataIndex: "idNo",
      },
      {
        title: "Old NRIC No./Passport No.",
        key: "otherIdNo",
        dataIndex: "otherIdNo",
      }, */
      {
        title: "Date Of Birth",
        key: "dob",
        dataIndex: "dob",
      },
      {
        title: "Email Address",
        key: "email",
        dataIndex: "email",
      },
      {
        title: "Last Update",
        key: "lastTransaction",
        dataIndex: "lastTransaction",
      },
      {
        title: "No. Of Quotation Created",
        key: "quotationCount",
        dataIndex: "quotationCount",
      },
      {
        title: "No. Of Proposal Created",
        key: "proposalCount",
        dataIndex: "proposalCount",
      },
      {
        title: "Action",
        key: "action",
        dataIndex: "action",
        fixed: "right",
        width: 100,
      },
    ],
    dataMapping: {
      body: [
        {
          item: {
            caption: "Customer Name",
            value: "name",
          },
        },
        {
          item: {
            caption: "New NRIC No.",
            value: "idNo",
          },
        },
        {
          item: {
            caption: "Old NRIC No./Passport No.",
            value: "otherIdNo",
          },
        },
        {
          item: {
            caption: "Date Of Birth",
            value: "dob",
          },
        },
        {
          item: {
            caption: "Email Address",
            value: "email",
          },
        },
        {
          item: {
            caption: "Last transaction",
            value: "lastTransaction",
          },
        },
      ],
      footer: [
        {
          item: {
            caption: "Creation Date",
            value: "createdOn",
          },
        },
        {
          item: {
            caption: "Last Update",
            value: "updatedOn",
          },
        },
      ],
    },
    tabBarMapping: {
      all: {
        label: "All",
        value: "ALL",
      },
      draft: { label: "Draft", value: "DRAFT" },
      pending: { label: "Pending", value: "PENDING" },
      generated: { label: "Generated", value: "GENERATED" },
    },
    statusMapping: {
      DRAFT: {
        label: "Draft",
        color: "#FCEACF",
      },
      PENDING: {
        label: "Pending",
        color: "#FFE5DD",
      },
      GENERATED: {
        label: "Generated",
        color: "#66CCA733",
      },
      UNDEFINED: {
        label: "Undefined",
        color: "grey",
      },
    },
    dataDetailMapping: {
      personalDetails: [
        {
          item1: "name",
          item2: "typeId",
        },
        {
          item1: "idNo",
          item2: "otherIdNo",
        },
        {
          item1: "dob",
          item2: "anb",
        },
        {
          item1: "dateOfQuotation",
          item2: null,
        },
      ],
      financialDetails: [
        {
          item1: "financingBank",
          item2: "financingAccNo",
        },
        {
          item1: "bankRefNo",
          item2: "eligibleB40",
        },
        {
          item1: "financingAmount",
          item2: "financingPercentage",
        },
        {
          item1: "coveredFinancingAmount",
          item2: "assuredBankRate",
        },
        {
          item1: "financingPeriod",
          item2: "derefmentPeriod",
        },
      ],
      takafulDetails: [
        {
          item1: "termOfCoverage",
          item2: "initialSumCovered",
        },
        {
          item1: "contributionAmount",
          item2: "contributionMode",
        },
        {
          item1: "contributionType",
          item2: "financingPercentage",
        },
      ],
      uploaded_document: [
        {
          item1: "termOfCoverage",
          item2: "initialSumCovered",
        },
        {
          item1: "contributionAmount",
          item2: "contributionMode",
        },
      ],
    },
  },
  formDetailMapping: {
    personal_detail: "PERSONAL_DETAILS",
    financial_detail: "FINANCING_DETAILS",
    product_detail: "PRODUCT_DETAILS",
  },
  formProposalDetailMappingCode: {
    salesRepresentativeDetail: "SALES_REPRESENTATIVE",
    mortgageDetails: "MORTGAGE_DETAILS",
    personalDetails: "PERSONAL_DETAILS",
    companyDetails: "COMPANY_DETAILS",
    consentDeclaration: "CONSENT_DECLARATION",
  },
  formProposalDetailMapping: [
    {
      category: "SALES_REPRESENTATIVE",
      field: "salesRepresentativeDetail",
    },
    {
      category: "MORTGAGE_DETAILS",
      field: "mortgageDetails",
    },
    {
      category: "PERSONAL_DETAILS",
      field: "personalDetails",
    },
    {
      category: "CONSENT_DECLARATION",
      field: "consentDeclaration",
    },
  ],
  proposalDataDetailsMapping: {
    personalDetails: [
      {
        item1: "name",
        item2: "gender",
      },
      {
        item1: "idNo",
        item2: "otherIdNo",
      },
      {
        item1: "dob",
        item2: "anb",
      },
      {
        item1: "maritalStatus",
        item2: "race",
      },
      {
        item1: "nationality",
        item2: "countryOfBirth",
      },
      {
        item1: "height",
        item2: "weight",
      },
      {
        item1: "smoked",
      },
      {
        item1: "sticksPerDay",
        item2: "yearsOfSmoked",
      },
      {
        item1: "anb",
        item2: "occupation",
      },
      {
        item1: "occupationExactDuty",
        item2: "annualIncome",
      },
      {
        item1: "relationship",
        item2: "purposeOfProposal",
      },
      {
        item1: "countryCodeMobile",
        item2: "mobileNumber",
      },
      {
        item1: "countryCodeResidenceTel",
        item2: "residenceContact",
      },
      {
        item1: "countryCodeBusinessTel",
        item2: "businessContact",
      },
      {
        item1: "email",
      },
      {
        item1: "correspondenceAddressLine1",
      },
      {
        item1: "correspondenceAddressLine2",
      },
      {
        item1: "correspondenceAddressLine3",
      },
      {
        item1: "correspondenceAddressPostCode",
        item2: "correspondenceAddressCityName",
      },
      {
        item1: "correspondenceAddressState",
        item2: "correspondenceAddressCountry",
      },
      {
        item1: "residentAddressLine1",
      },
      {
        item1: "residentAddressLine2",
      },
      {
        item1: "residentAddressLine3",
      },
      {
        item1: "residentAddressPostCode",
        item2: "residentAddressCityName",
      },
      {
        item1: "residentAddressState",
        item2: "residentAddressCountry",
      },
      {
        item1: "employerAddressLine1",
      },
      {
        item1: "employerAddressLine2",
      },
      {
        item1: "employerAddressLine3",
      },
      {
        item1: "employerAddressPostCode",
        item2: "employerAddressCityName",
      },
      {
        item1: "employerAddressState",
        item2: "employerAddressCountry",
      },

      {
        item1: "insuranceCertificateDelivery",
      },
    ],
    salesRepresentativeDetails: [
      {
        item1: "salesRepresentativeName",
        item2: "branchCode",
      },
      {
        item1: "salesRepresentativeID",
        item2: "salesRepresentativeAgentCode",
      },
      {
        item1: "referralCode",
        item2: "campaignCode",
      },
      {
        item1: "sectorCode",
      },
    ],
    mortgageDetails: [
      {
        item1: "paymentMode",
        item2: "loanAccountNo",
      },
      {
        item1: "loanInterestRate",
        item2: "totalPayableAmount",
      },
      {
        item1: "basicPremium",
        item2: "ropPremium",
      },
      {
        item1: "loanAmount",
        item2: "initialSumAssured",
      },
      {
        item1: "constructionPeriod",
        item2: "defermentTerm",
      },
      {
        item1: "termOfCoverage",
        item2: null,
      },
    ],    
    companyDetails: [
      {
        item1: "registeredNameCompany",
        item2: "newCompanyRegistrationNo",
      },
      {
        item1: "companyCountry",
        item2: "companyAddress",
      },
      {
        item1: "countryCodeMobile",
        item2: "companyTel",
      },
      {
        item1: "companyEmail",
        item2: null,
      }
    ]
  },

  idTypesMapping: {
    newRIC: ["MYKA", "MYPR", "MYKAS"],
    otherIdNo: ["MYTE", "MYPR", "MYPO", "PASP"],
    oldNRIC: "ORIC",
  },

  tabsMapping: [
    { value: "myProfile", caption: Labels.LBL_MY_PROFILE },
    { value: "prudentialProfile", caption: Labels.LBL_PRUDENTIAL_PROFILE },
    { value: "uobProfile", caption: Labels.LBL_UOB_PROFILE },
    /* { value: "quicklinks", caption: "QUICK LINKS" }, */
  ],

  prudentialProfileContent: {
    title: Labels.LBL_PRUDENTIAL_PROFILE_HEADER,
    contents: [
      "Prudential Assurance Malaysia Berhad (PAMB) is a leading and innovative insurer, serving the savings, protection, and investment needs of Malaysians by offering a full range of financial solution through its branches, agency force and bancassurance distribution partners network nationwide.",
      "Its purpose is to help people get the most out of life by making healthcare affordable and accessible, protecting people’s wealth and growing their assets, and empowering its customers to save for their goals.",
      "PAMB was established in Malaysia in 1924 and is a subsidiary of Prudential plc, which was founded in London in 1848. Prudential plc provides life and health insurance and asset management, with a focus on Asia and Africa. ",
      "Prudential plc is not affiliated in any manner with Prudential Financial, Inc, a company whose principal place of business is in the United States of America.",
    ],
    footer: "",
  },

  uobProfileContent: {
    title: Labels.LBL_UOB_PROFILE_HEADER,
    contents: [
      "UOB (Malaysia) is rated among the top banks in Malaysia with a long-term AAA rating from Ratings Agency of Malaysia. It has over seven decades of presence in the country, and operates 55 branches nationwide, offering both conventional and Islamic banking services to its customers.",
      "UOB (Malaysia) is a subsidiary of UOB, a leading bank in Asia with a global network of around 500 offices in 19 countries and territories in Asia Pacific, Europe, and North America. UOB has adopted a customer-centric approach to creating long-term value by staying relevant through its enterprising spirit and doing right by its customers. UOB is focused on building the future of ASEAN – for the people and businesses within, and connecting with ASEAN.",
      "The Bank connects businesses to opportunities in the region with its unparalleled regional footprint and leverages data and insights to innovate and create personalised banking experiences and solutions catering to each customer’s unique needs and evolving preferences. UOB is also committed to helping businesses forge a sustainable future, by fostering social inclusiveness, creating positive environmental impact and pursuing economic progress. UOB believes in being a responsible financial services provider and is steadfast in its support of art, social development of children and education, doing right by its communities and stakeholders.",
    ],
    footer: "",
  },
};

export default Config;
